import { Button, Card, Form, Input, Select, Upload } from 'antd';
import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { searchExperienceActions } from '../../lib/api-client.ts';
import { CloseOutlined, UploadOutlined } from '@ant-design/icons';

type Props = {
  index: number;
  onRemove: () => void;
};

export const PlayFormItem = (props: Props) => {
  const { index: i, onRemove } = props;
  const [query, setQuery] = useState('');
  const { data: actions, isLoading } = useQuery({
    queryKey: ['actions', query],
    queryFn: searchExperienceActions,
  });
  const options = actions?.map((action) => ({ label: action.title, value: action.id })) || [];
  const images = Form.useWatch(['activities', i, 'images']);
  const hasAction = !!Form.useWatch(['activities', i, 'actionId']);
  const hasActionGlobal =
    (Form.useWatch(['activities']) || []).filter((f: any) => f?.actionId).length === 0;
  const activityCount = Form.useWatch('activities')?.length;

  return (
    <Card title={`活動${i + 1}`} extra={activityCount > 2 && <CloseOutlined onClick={onRemove} />}>
      <Form.Item
        label="タイトル"
        name={[i, 'title']}
        rules={[{ required: true, message: 'タイトルを入力してください' }]}
      >
        <Input />
      </Form.Item>
      <Form.Item
        label="内容"
        name={[i, 'description']}
        rules={[
          { required: true, message: '活動の内容を入力してください' },
          { max: 300, message: '300文字以内で入力してください' },
        ]}
      >
        <Input.TextArea />
      </Form.Item>
      <Form.Item
        label="特徴的な行動"
        name={[i, 'actionId']}
        rules={[
          { required: hasActionGlobal, message: '全体で一つは特徴的な行動を選択してください' },
        ]}
      >
        <Select
          showSearch
          allowClear
          onSearch={setQuery}
          options={options}
          loading={isLoading}
          filterOption={false}
        />
      </Form.Item>
      <Form.Item
        label="具体的エピソード"
        name={[i, 'actionEpisode']}
        rules={[
          { max: 300, message: '300文字以内で入力してください' },
          { required: hasAction, message: '具体的エピソードを入力してください' },
        ]}
      >
        <Input.TextArea />
      </Form.Item>
      <Form.Item label="画像" name={[i, 'images']}>
        <Upload
          name="files"
          action={`${import.meta.env.VITE_API_URL}/blobs`}
          listType="picture"
          multiple
          accept="image/*"
          fileList={images?.fileList || []}
        >
          <Button icon={<UploadOutlined />}>アップロード</Button>
        </Upload>
      </Form.Item>
    </Card>
  );
};
